var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlaceholderDark20 = function SvgPlaceholderDark20(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.639 5.833 10 9.306 2.361 5.833M10 9.306v9.027",
    stroke: "#F6F7F8",
    strokeOpacity: 0.72,
    strokeWidth: 1.333,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M2.361 5.139 10 1.667l7.639 3.472v9.722L10 18.333l-7.639-3.472V5.14Z",
    stroke: "#F6F7F8",
    strokeWidth: 1.333,
    strokeLinejoin: "round"
  })));
};
export default SvgPlaceholderDark20;